import {Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {getTranslationKey} from '../../utils'

type Props = {
  overdue: number
  totalOverdue: number
  timeLabel: string
  translationPrefix?: string
}

export const WorkOrdersOverdueTooltipTitle = ({
  overdue,
  totalOverdue,
  timeLabel,
  translationPrefix
}: Props) => {
  const {t} = useTranslation()

  return (
    <Stack spacing={0.5}>
      <Typography fontWeight="medium">
        {`${totalOverdue} ${t(
          getTranslationKey('workOrderSummary.label.overdue', translationPrefix)
        )} (${t(getTranslationKey('label.allTime', translationPrefix))})`}
      </Typography>
      <Typography>
        {`${overdue} ${t(
          getTranslationKey('workOrderSummary.label.overdue', translationPrefix)
        )} (${timeLabel})`}
      </Typography>
    </Stack>
  )
}
